import axios from 'axios'
import qs from 'qs'
import prefixedUrl from './helpers/prefixedUrl'

// Отдельный клиент: целевая компания находится в URL, общие заголовки CRM не меняются.
const client = axios.create({
    timeout: 20000,
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' }),
})
const sessionHeaders = ['Authorization', 'session-id', 'session-identity', 'unique-id', 'sms-token']

async function request(method, path, { params, data, timeout } = {}) {
    const source = window.axios?.defaults?.headers?.common || {}
    const headers = {}
    sessionHeaders.forEach(name => {
        const key = Object.keys(source).find(key => key.toLowerCase() === name.toLowerCase())
        if (key && source[key] !== undefined && source[key] !== false) headers[name] = source[key]
    })
    try {
        const response = await client.request({
            method,
            url: prefixedUrl(`/operator-workspace/v1/${path}`),
            headers,
            params,
            data,
            ...(timeout ? { timeout } : {}),
        })
        return response.data
    } catch (error) {
        const failure = new Error(
            error.response?.data?.error?.message || error.response?.data?.message || 'Не удалось связаться с сервером'
        )
        failure.status = error.response?.status || 0
        failure.requestId = error.response?.data?.meta?.request_id
        throw failure
    }
}

const companyPath = companyId => `companies/${encodeURIComponent(companyId)}`
const chatPath = tab => `${companyPath(tab.company_id)}/chats/${encodeURIComponent(tab.id)}`

export default {
    context: () => request('get', 'context'),
    inbox: params => request('get', 'inbox', { params }),
    counters: params => request('get', 'counters', { params }),
    reference: companyId => request('get', `${companyPath(companyId)}/reference`),
    crmSession: (companyId, parkId, purpose = 'create_driver') =>
        request('post', `${companyPath(companyId)}/crm-session`, { data: { park_id: parkId || null, purpose } }),
    chat: tab => request('get', chatPath(tab)),
    messages: (tab, params) => request('get', `${chatPath(tab)}/messages`, { params }),
    action: (tab, action, data) => request('post', `${chatPath(tab)}/${action}`, { data }),
    sendStatus: (tab, id) => request('get', `${chatPath(tab)}/send-operations/${encodeURIComponent(id)}`),
    resolveSend: (tab, id, data) =>
        request('post', `${chatPath(tab)}/send-operations/${encodeURIComponent(id)}/resolve`, { data }),
    startChat: (companyId, data) => request('post', companyPath(companyId) + '/chats', { data }),
    archive: (companyId, params) => request('get', companyPath(companyId) + '/archive', { params }),
    transcribe: (tab, message) =>
        request(
            'post',
            message.archived
                ? companyPath(tab.company_id) + '/history-messages/' + message.id + '/transcribe'
                : chatPath(tab) + '/files/' + message.id + '/transcribe',
            { timeout: 75000 }
        ),
    history: (tab, params) =>
        request('get', `${companyPath(tab.company_id)}/customers/${tab.customer_id}/history/messages`, { params }),
    historyList: (tab, params) =>
        request('get', `${companyPath(tab.company_id)}/customers/${tab.customer_id}/history`, { params }),
    historyMessages: (tab, historyId, params) =>
        request('get', `${companyPath(tab.company_id)}/histories/${encodeURIComponent(historyId)}/messages`, {
            params,
        }),
    file: (tab, message) =>
        request(
            'get',
            message.archived
                ? `${companyPath(tab.company_id)}/history-messages/${message.id}/file`
                : `${chatPath(tab)}/files/${message.id}`
        ),
    cards: tab => request('get', `${companyPath(tab.company_id)}/cards/lookup`, { params: { phone: tab.phone } }),
    driver: (companyId, driver) =>
        request(
            'get',
            `${companyPath(companyId)}/cards/parks/${driver.park_id}/drivers/${encodeURIComponent(driver.id)}`
        ),
    driverTab: (companyId, driver, section, params) =>
        request(
            'get',
            `${companyPath(companyId)}/cards/parks/${driver.park_id}/drivers/${encodeURIComponent(
                driver.id
            )}/${section}`,
            { params }
        ),
    candidate: (companyId, id) => request('get', `${companyPath(companyId)}/cards/candidates/${id}`),
    document: (companyId, driver, id) =>
        request(
            'get',
            `${companyPath(companyId)}/cards/parks/${driver.park_id}/drivers/${encodeURIComponent(
                driver.id
            )}/documents/${id}`
        ),
    comment: (companyId, driver, comment) =>
        request(
            'post',
            `${companyPath(companyId)}/cards/parks/${driver.park_id}/drivers/${encodeURIComponent(driver.id)}/comments`,
            { data: { comment } }
        ),
    subscribe: data => request('put', 'subscriptions/current', { data }),
    unsubscribe: () => request('delete', 'subscriptions/current'),
    callContext: id => request('get', `calls/${encodeURIComponent(id)}`),
    prepareCall: (companyId, phone) => request('post', `${companyPath(companyId)}/calls/prepare`, { data: { phone } }),
    transferCall: (callId, targetAgentId) =>
        request('post', `calls/${encodeURIComponent(callId)}/transfer`, { data: { target_agent_id: targetAgentId } }),
}
